const INITIAL_STATE = { list: [], ativaPercentualDesconto:false, ativaValorDesconto:false }

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'UNIDADE_FETCHED':
            return { ...state, list: action.payload.data }
        default: return state
    }
}


// WEBPACK FOOTER //
// ./src/unidade/unidadeReducer.js